import {GenericServices} from 'max-ng-lib';
import {environment} from '../../environments/environment';
import {catchError, finalize, take, tap} from 'rxjs/operators';
import {Observable} from 'rxjs';

export abstract class GenericServicesMotoristaService extends GenericServices {
	constructor() {
		super();
	}

	getBaseURL(): string {
		return environment.BASE_URL;
	}

	gerarRelatorioBody(url, params) {
		this.disparaLoading(true);
		return this.getHttpClient().post(`${this.getBaseURL()}${url}`, params,
			{responseType: 'blob'})
			.pipe(
				take(1),
				finalize(this.removerLoading.bind(this, true)),
				catchError((err) => {
					if (
						err.error instanceof Blob &&
						err.error.type === 'application/json'
					) {
						return new Promise<any>((resolve, reject) => {
							let reader = new FileReader();
							reader.onload = (e: Event) => {
								try {
									const errmsg = JSON.parse(
										(<any>e.target).result
									);
									reject(
										this.tratarErro(
											errmsg.erros[0],
											true,
											'Erro ao gerar relatório'
										)
									);
								} catch (e) {
									reject(err);
								}
							};
							reader.onerror = (e) => {
								reject(err);
							};
							reader.readAsText(err.error);
						});
					}
					return this.tratarErro(
						err,
						true,
						'Erro ao gerar relatório'
					);
				})
			);
	}

	gerarRelatorio(url, params) {
		this.disparaLoading(true);
		return this.getHttpClient()
			.get(`${this.getBaseURL()}${url}`, {
				params: params,
				responseType: 'blob',
			})
			.pipe(
				take(1),
				finalize(this.removerLoading.bind(this, true)),
				catchError((err) => {
					if (
						err.error instanceof Blob &&
						err.error.type === 'application/json'
					) {
						return new Promise<any>((resolve, reject) => {
							let reader = new FileReader();
							reader.onload = (e: Event) => {
								try {
									const errmsg = JSON.parse(
										(<any>e.target).result
									);
									reject(
										this.tratarErro(
											errmsg.erros[0],
											true,
											'Erro ao gerar relatório'
										)
									);
								} catch (e) {
									reject(err);
								}
							};
							reader.onerror = (e) => {
								reject(err);
							};
							reader.readAsText(err.error);
						});
					}
					return this.tratarErro(
						err,
						true,
						'Erro ao gerar relatório'
					);
				})
			);
	}

	abrirNovaGuia(result) {
		const url = window.URL.createObjectURL(result);
		window.open(url);
	}

	baixarRelatorio(result, nomeRelatorio) {
		const url = window.URL.createObjectURL(result);
		const a = document.createElement('a');
		document.body.appendChild(a);
		a.setAttribute('style', 'display: none');
		a.href = url;
		a.download = nomeRelatorio;
		a.click();
		window.URL.revokeObjectURL(url);
		a.remove();
	}

   /* O código abaixo é para imprimir o traceId em caso de erro na requisição no console.log
   * infelizmente usamos essa lib compilada da maxima que intercepta o erro e já joga num msgService
   * impedindo de colocar o console.log lá dentro. Futuramente pretendo migrar essa lib para dentro do projeto
   * porém até lá, estou fazendo override dos get,post,delete,put para que seja incluido o console.log
   */

	get<T>(servico: string, options: any = {}): Observable<T> {
		return super.get<T>(servico, options).pipe(
			catchError((err) => {
				if (err.error && err.error.erros && err.error.erros.length > 0) {
					console.log('Api trace erro:', err.error.erros[0].traceApiId);
				}
				throw err;
			})
		);
	}


	post<T>(servico: string, options: any = {}): Observable<T> {
		return super.post<T>(servico, options).pipe(
			catchError((err) => {
				if (err.error && err.error.erros && err.error.erros.length > 0) {
					console.log('Api trace erro:', err.error.erros[0].traceApiId);
				}
				throw err;
			})
		);
	}

	put<T>(servico: string, options: any = {}): Observable<T> {
		return super.put<T>(servico, options).pipe(
			catchError((err) => {
				if (err.error && err.error.erros && err.error.erros.length > 0) {
					console.log('Api trace erro:', err.error.erros[0].traceApiId);
				}
				throw err;
			})
		);
	}

	delete(servico: string, options: any = {}): Observable<Object> {
		return super.delete(servico, options).pipe(
			catchError((err) => {
				if (err.error && err.error.erros && err.error.erros.length > 0) {
					console.log('Api trace erro:', err.error.erros[0].traceApiId);
				}
				throw err;
			})
		);
	}
}
